'use client';
import { useEffect } from 'react';
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';

/**
 * Locks the entire screen from scrolling if the passed in value is true
 * @param lockIfTrue If this value is true, then lock scrolling
 * @param element - Pass in an element that should allow for scrolling on if the body is locked
 */
export const useScrollLock = (lockIfTrue: boolean, query: string): void => {
  useEffect(() => {
    const element = document?.querySelector(query);
    if (lockIfTrue && element) {
      disableBodyScroll(element);
    }

    return () => {
      if (element) {
        clearAllBodyScrollLocks();
      }
    };
  }, [lockIfTrue, query]);
};
